import React from 'react';
import { useTranslation } from 'react-i18next';

import ProjectItem from './ProjectItem';
import { ConfirmModal } from 'components/Modal/ConfirmModal';

import { sortBy } from 'lodash';
import { Row, Col } from 'antd';
interface ProjectListProps {
	list: [],
	onSelectProject: (project: any) => {},
	onClone: (id: string) => {},
	onDelete: (id: string) => {},
	canClone: false,
	refetch: () => {},
	tutorialPopover: null,
	pushModal: (modal: any) => {},
	popModal: () => {},
	authorizedProjectTypes: {
		pro: boolean,
		stakeholders: boolean,
		risks: boolean
	}
};

export const ProjectsList = (props: ProjectListProps) => {
	const { t } = useTranslation();

	const askDeleteConfirmation = async (id?: string, name?: string) => {
		props.pushModal(
			<ConfirmModal
				title={t('models.project.messages.delete_confirmation')}
				t={t}
				onConfirm={() => props.onDelete(id)}
				message={t(
					'models.project.messages.delete_confirmation_explanation', {
					name
				}
				)}
			></ConfirmModal>
		);
	};

	const askCloneConfirmation = async (id, values) => {

		console.log('askCloneConfirmation', id, values);

		props.pushModal(
			<ConfirmModal
				title={t('models.project.messages.clone_confirmation')}
				onConfirm={async (values: Object) => {
					await props.onClone(id);
					props.popModal();
				}}
				t={t}
				id={values?.id}
				key={values?.id || 'new'}
				values={{
					name: values?.name + ' - Copy',
					reference: "",
				}}
				message={t(
					'models.project.messages.clone_confirmation_explanation'
				)}
				authorizedTypes={props.authorizedProjectTypes}
			></ConfirmModal>
		)
	}

	return (
		<>
			<Row gutter={[8, 8]} justify={"center"} className="ProjectsList mb-1">
				{
					sortBy((props.list || []), ["name", "reference", "createdAt"]).map((value: any, index: Number) =>
						<Col xs={24} sm={22} md={11} lg={8} xl={7} key={value?.id}>
							<ProjectItem
								onDelete={() => {
									askDeleteConfirmation(value?.id, value?.name);
								}}
								onClick={props.onSelectProject}
								onClone={
									props.canClone
										? (e: any) => {
											askCloneConfirmation(
												value?.id
											);
											return false;
										}
										: null
								}
								key={value?.id}
								details={value}
							></ProjectItem>


						</Col>
					)
				}
			</Row >
		</>
	);
};
